import { PAGES } from "@dune/types";
import { Navigate, Outlet } from "react-router-dom";
import { useCheckAuth } from "../api/queries/auth.queries";

export const RequireAuth = () => {
	const { isLoading, isError } = useCheckAuth();

	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<h1 className="text-3xl font-semibold">Connexion ...</h1>
			</div>
		);
	}

	if (isError) {
		return <Navigate to={PAGES.LOGIN} />;
	}

	return <Outlet />;
};
